import styled, { css } from "styled-components";
import { color } from "@m/alchemy-theme";
export const Hero = styled.path ``;
export const Wrapper = styled.svg `
  width: ${({ size }) => (size === "small" ? 192 : 288)}px;
  max-width: 100%;

  ${Hero} {
    fill: ${({ palette }) => color("base", { palette })};
  }
`;
export const Highlight = styled.path `
  fill: ${color("highlight", { palette: "expressiveNeutral" })};
`;
export const Hint = styled.path `
  fill: ${color("hint", { palette: "expressiveNeutral" })};
`;
export const Base = styled.path `
  fill: ${color("base", { palette: "expressiveNeutral" })};
`;
export const HintPanelSwapWhite = styled.path `
  fill: ${({ isPanel }) => (isPanel ? "#fff" : color("hint", { palette: "expressiveNeutral" }))};
`;
export const BackgroundGroup = styled.g `
  opacity: 0.7;
  ${HintPanelSwapWhite} {
    ${({ activeColorScheme }) => activeColorScheme && activeColorScheme === "alchemyDark"
    ? css `
            fill: #fff;
          `
    : ""}
  }

  ${Hint} {
    ${({ activeColorScheme }) => activeColorScheme && activeColorScheme === "alchemyDark"
    ? css `
            fill: ${(props) => color("base")(props)};
          `
    : ""}
  }

  ${Highlight} {
    ${({ activeColorScheme }) => activeColorScheme && activeColorScheme === "alchemyDark"
    ? css `
            fill: ${(props) => color("base")(props)};
          `
    : ""}
  }
`;
